export function sanitizeItinerary(text) {
  if (!text) return text;
  text = text.replace(/\*\*([^*]*)\*\*/g, '$1').replace(/\*\*/g, '');
  const STRIP_PATTERNS = [
    /===.*===/g,
    /```[\s\S]*?```/g,
    // 마커형 마크다운 헤더 (### ITINERARY_START ###, ### 날짜별 일정 ###, ## SPOTS ## 등)
    /^#{1,6}\s*(ITINERARY|SPOTS|SUMMARY|PROFILE|날짜별\s*일정|성향\s*분석|여행자\s*정보|최종\s*일정)[_\s]?(START|END)?\s*#*\s*$/gim,
    /^#{1,6}\s*[-=]{3,}\s*$/gm, // ###---###
    /\[언어\s*(규칙|지시|설정)[^\]]*\]/g,
    /\[반드시[^\]]*\]/g,
    /\[중요[^\]]*\]/g,
    /\[주의[^\]]*\]/g,
    /\[금지[^\]]*\]/g,
    /\[LANGUAGE[^\]]*\]/gi,
    /\[FORMAT[^\]]*\]/gi,
    /\[RULE[^\]]*\]/gi,
  ];
  const STRIP_LINES = [
    /한국어로\s*(작성|답변|출력|생성)/,
    /중국어.*(금지|사용하지|사용하면|절대)/,
    /위\s*내용은\s*한국어/,
    /언어\s*(규칙|지시|설정)/,
    /반드시\s*한국어/,
    /중국어\s*절대/,
    /^(규칙|반드시|절대|You are|System|Assistant|User|Human|Note|주의|지침|지시|형식|포맷|FORMAT|RULE|INSTRUCTION|OUTPUT)[\s:：]/i,
    /^(Here is|Here's|Below is|The following|Note that|Please note|Important|I have|I will|I'll|Let me|As requested|Based on)/i,
    /汉字|漢字|chinese|mandarin/i,
  ];
  let result = text;
  STRIP_PATTERNS.forEach(p => { result = result.replace(p, ''); });
  result = result.split('\n').filter(line => {
    const t = line.trim();
    if (!t) return true;
    return !STRIP_LINES.some(p => p.test(t));
  }).join('\n');
  result = result.replace(/\n{3,}/g, '\n\n');
  return result.trim();
}

export function getWeatherStyle(line, dm=false) {
  const t=line.toLowerCase();
  if(t.includes("비")||t.includes("소나기")||t.includes("우산")) return { bg:"rgba(100,150,255,0.12)", border:"rgba(100,150,255,0.3)", icon:"🌧️" };
  if(t.includes("눈")) return { bg:"rgba(200,230,255,0.1)", border:"rgba(200,230,255,0.3)", icon:"❄️" };
  if(t.includes("맑음")||t.includes("야외")) return { bg:"rgba(255,200,50,0.1)", border:"rgba(255,200,50,0.3)", icon:"☀️" };
  if(t.includes("흐림")||t.includes("안개")) return { bg:"rgba(180,180,180,0.1)", border:"rgba(180,180,180,0.25)", icon:"☁️" };
  if(t.includes("썬크림")||t.includes("자외선")) return { bg:"rgba(255,160,50,0.12)", border:"rgba(255,160,50,0.3)", icon:"🧴" };
  return { bg:"rgba(100,200,150,0.1)", border:"rgba(100,200,150,0.25)", icon:"🌤️" };
}

export const hasChinese = (text) => /[一-鿿㐀-䶿]/.test(text);

export const calcBadges = (userReviews, planCount) => {
  const earned = new Set();
  if(planCount >= 1)  earned.add("first_plan");
  if(planCount >= 10) earned.add("planner10");
  if(userReviews.length >= 1) earned.add("reviewer");
  if(userReviews.length >= 3) earned.add("reviewer3");
  if(userReviews.some(r => r.rating === 5)) earned.add("five_star");
  const dests = new Set(userReviews.map(r=>r.destination));
  if(dests.size >= 3) earned.add("globetrotter");
  if(userReviews.some(r => r.scores?.food >= 5)) earned.add("foodie");
  if(userReviews.some(r => r.photos?.length >= 5)) earned.add("photographer");
  const totalLikes = userReviews.reduce((s,r) => s+(r.likes||0), 0);
  if(totalLikes >= 5) earned.add("liked");
  return [...earned];
};
